// =====================================
//
//   商品自定義規格 Directive
//
//   Author: Gray
//   createtime: 2017 / 07 / 26
//   updatetime: 2018 / 12 / 19
//
// =====================================

window.InifECApp.controller("CustomSpecController", ['ProductUtil', '$scope',
    function(ProductUtil, $scope) {

        var PdtSpecProps = ProductUtil.PdtSpecProps; // 商品規格所有欄位
        var CountKey = "count"; // 數量key
        var DimensionKey = "dimension"; // 尺寸key
        var ProcessKey = "process"; // 加工key
        var ImageDimensionKey = "imageDimension"; // 印刷尺寸key
        var CountLayoutType = {
            Custom: 2, // 輸入框
            ClothinghSize: 3, // 尺碼與件數
        }

        // --------------------------------
        // 展開所有規格
        // --------------------------------
        var expandSpec = function(products) {

            var printingUnitMap = {};
            var processMap = {};

            var specPropsMap = {
            };

            var supportProps = {
            };

            var updateSupportPropsAndSpecPropsMap = function(value, prop, isObject, fixedkey) {

                if(!value) {
                    return;
                }

                var mapkey;

                if(fixedkey) {
                    mapkey = fixedkey;
                } else if(isObject) {

                    var ordered = {};

                    Object.keys(value).sort().forEach(function(key) {
                        ordered[key] = value[key];
                    });

                    mapkey = JSON.stringify(ordered);
                } else {
                    mapkey = value;
                }

                if(!specPropsMap[prop]) {
                    specPropsMap[prop] = {};
                }

                specPropsMap[prop][mapkey] = value;
                supportProps[prop] = true;
            }

            for(var i = 0; i < products.length; i++) {
                var product = products[i];

                if(Array.isArray(product.specs) && product.specs.length > 0) {
                    for(var j = 0; j < product.specs.length; j++) {
                        var spec = product.specs[j];
                        var specProps = spec.specProps;
                        var specValue;
                        var specValueList;

                        // spec 的資料
                        specValue = spec.printingUnit;
                        if(specValue) {
                            printingUnitMap[specValue] = specValue;
                        }

                        specValueList = spec.process;
                        if(Array.isArray(specValueList) && specValueList.length > 0) {
                            for(var k = 0; k < specValueList.length; k++) {
                                specValue = specValueList[k];
                                var key = JSON.stringify(specValue);
                                processMap[key] = specValue;
                            }
                        }

                        specValueList = spec.offerProcess;
                        if(Array.isArray(specValueList) && specValueList.length > 0) {
                            for(var k = 0; k < specValueList.length; k++) {
                                specValue = specValueList[k];
                                var key = JSON.stringify(specValue);
                                processMap[key] = specValue;
                            }
                        }

                        // specProps 的資料
                        if(specProps[PdtSpecProps.Length]) {
                            supportProps[PdtSpecProps.Length] = true;
                            supportProps[DimensionKey] = true;
                        }

                        if(specProps[PdtSpecProps.Width]) {
                            supportProps[PdtSpecProps.Width] = true;
                            supportProps[DimensionKey] = true;
                        }

                        if(specProps[PdtSpecProps.Height]) {
                            supportProps[PdtSpecProps.Height] = true;
                            supportProps[DimensionKey] = true;
                        }

                        if(specProps[PdtSpecProps.IsOneSide] !== undefined) {
                            supportProps[PdtSpecProps.IsOneSide] = true;
                        }

                        if(specProps[PdtSpecProps.IsTwoSide] !== undefined) {
                            supportProps[PdtSpecProps.IsTwoSide] = true;
                        }

                        specValue = specProps[PdtSpecProps.SizeUnit];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.SizeUnit, false);
                        specValue = specProps[PdtSpecProps.AreaRange];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.AreaRange, true);
                        specValue = specProps[PdtSpecProps.Thickness];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.Thickness, false);
                        specValue = specProps[PdtSpecProps.ThicknessUnit];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.ThicknessUnit, false);
                        specValue = specProps[PdtSpecProps.PdtStyle];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.PdtStyle, false);
                        specValue = specProps[PdtSpecProps.MaterialType];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.MaterialType, false);
                        specValue = specProps[PdtSpecProps.Volume];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.Volume, false);
                        specValue = specProps[PdtSpecProps.Version];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.Version, false);
                        specValue = specProps[PdtSpecProps.Dpi];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.Dpi, false);

                        if(specProps[PdtSpecProps.ImageLength]) {
                            supportProps[PdtSpecProps.ImageLength] = true;
                            supportProps[ImageDimensionKey] = true;
                        }

                        if(specProps[PdtSpecProps.ImageWidth]) {
                            supportProps[PdtSpecProps.ImageWidth] = true;
                            supportProps[ImageDimensionKey] = true;
                        }

                        specValue = specProps[PdtSpecProps.ImageSizeUnit];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.ImageSizeUnit, false);

                        specValue = specProps[PdtSpecProps.SleeveLength];
                        updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.SleeveLength, false);

                        specValueList = specProps[PdtSpecProps.ColorHexList];
                        if(Array.isArray(specValueList) && specValueList.length > 0) {
                            for(var k = 0; k < specValueList.length; k++) {
                                specValue = specValueList[k];
                                var fixedkey = specValue.hex;
                                if(specValue.subHex) {
                                    fixedkey += specValue.subHex;
                                }

                                fixedkey = fixedkey.toUpperCase();
                                updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.ColorHex, true, fixedkey);
                            }
                        }

                        specValueList = specProps[PdtSpecProps.ClothingSizeList];
                        if(Array.isArray(specValueList) && specValueList.length > 0) {
                            for(var k = 0; k < specValueList.length; k++) {
                                specValue = specValueList[k];
                                var fixedkey = specValue.clothingSizeunit;
                                updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.ClothingSizeList, true, fixedkey);
                            }
                        }

                        specValueList = specProps[PdtSpecProps.PrintingColorCountList];
                        if(Array.isArray(specValueList) && specValueList.length > 0) {
                            for(var k = 0; k < specValueList.length; k++) {
                                specValue = specValueList[k];
                                updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.PrintingColorCount, true);
                            }
                        }

                        specValueList = specProps[PdtSpecProps.PrintingAreaList];
                        if(Array.isArray(specValueList) && specValueList.length > 0) {
                            for(var k = 0; k < specValueList.length; k++) {
                                specValue = specValueList[k];
                                updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.PrintingAreaList, true, specValue.name);
                            }
                        }

                        specValueList = specProps[PdtSpecProps.PrintingPathCountList];
                        if(Array.isArray(specValueList) && specValueList.length > 0) {
                            for(var k = 0; k < specValueList.length; k++) {
                                specValue = specValueList[k];
                                updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.PrintingPathCount, true);
                            }
                        }

                        specValueList = specProps[PdtSpecProps.RollingColorHexList];
                        if(Array.isArray(specValueList) && specValueList.length > 0) {
                            for(var k = 0; k < specValueList.length; k++) {
                                specValue = specValueList[k];
                                var fixedkey = specValue.hex;
                                if(specValue.subHex) {
                                    fixedkey += specValue.subHex;
                                }

                                fixedkey = fixedkey.toUpperCase();
                                updateSupportPropsAndSpecPropsMap(specValue, PdtSpecProps.RollingColorHex, true, fixedkey);
                            }
                        }
                    }
                }
            }

            var printingUnitList = [];

            $.map(printingUnitMap, function(value, key) {
                if(key !== undefined && value !== undefined) {
                    printingUnitList.push(value);
                }
            });

            var processList = [];

            $.map(processMap, function(value, key) {
                if(key !== undefined && value !== undefined) {
                    processList.push(value);
                }
            });

            var selectListMap = {};

            $.map(specPropsMap, function(value, key) {
                selectListMap[key] = [];

                $.map(value, function(subValue, subKey) {
                    if(subKey !== undefined && subValue !== undefined) {
                        selectListMap[key].push(subValue);
                    }
                });

                selectListMap[key].sort(function(valueA, valueB) {
                    if(valueB.index == -1 && !valueA.index) {
                        return 1;
                    } else if(!valueB.index && valueA.index == -1) {
                        return -1;
                    } else {
                        return 0;
                    }
                });
            });

            $scope.printingUnitList = printingUnitList;
            $scope.processList = processList;
            $scope.selectListMap = selectListMap;
            $scope.supportProps = supportProps;
        }

        // ------------------------------
        // [SCOPE] 當選項值更改時
        // ------------------------------
        var onFormValueChange = function(option, key, isCustom) {

            if(!key) {
                return;
            }

            $scope.form[key] = option;
            $scope.isCustom[key] = isCustom;            
        }

        // ------------------------------
        // [SCOPE] 當自訂值更改時
        // ------------------------------
        var onCustomFormValueChange = function(key) {

            $scope.form[key] = $scope.customForm[key];
        }

        // ------------------------------
        // [SCOPE] 尺寸單位
        // ------------------------------
        var getSizeUnit = function(key) {

            var unit = $scope.form[key];

            return ProductUtil.getSizeUnitHtml(unit);
        }

        // ------------------------------
        // [SCOPE] 尺寸單位
        // ------------------------------
        var getSizeUnitByInt = function(unit) {

            return ProductUtil.getSizeUnitHtml(unit);
        }

        // -------------------------------
        // [SCOPE] 更換單/雙列印
        // -------------------------------
        var onSideChange = function(isTwoSide) {

            $scope.form[PdtSpecProps.IsOneSide] = !isTwoSide;
            $scope.form[PdtSpecProps.IsTwoSide] = isTwoSide;
        }

        // -------------------------------
        // [SCOPE] 更換單/雙列印
        // -------------------------------
        var onSideChange = function(isTwoSide) {

            $scope.form[PdtSpecProps.IsOneSide] = !isTwoSide;
            $scope.form[PdtSpecProps.IsTwoSide] = isTwoSide;
        }

        // --------------------------------
        // [SCOPE] 選取／取消 一般加工項目
        // -------------------------------
        var toggleProcess = function(_process) {

            if(!Array.isArray($scope.form.process)){
                $scope.form.process = [];
                $scope.form.process.push(_process);
                return;
            }

            for(var i = 0 ; i < $scope.form.process.length ; i++) {
                if($scope.form.process[i].key == _process.key) {
                    $scope.form.process.remove(i);
                    return;
                }
            }

            $scope.form.process.push(_process);
        }

        // --------------------------------
        // [SCOPE] 是否選取該一般加工項目
        // -------------------------------
        var isSelectedProcess = function(_process) {

            if(!Array.isArray($scope.form.process)){
                return false;
            }

            for(var i = 0 ; i < $scope.form.process.length ; i++) {
                if($scope.form.process[i].key == _process.key) {
                    return true;
                }
            }

            return false;
        }

        // --------------------------------
        // [SCOPE] 檢查是否有勾選一般加工項目
        // -------------------------------
        var checkSelectedProcess = function() {

            return $scope.form && $scope.form.process && $scope.form.process.length > 0;
        }

        // ------------------------------
        // 取得某個欄位的列表
        // ------------------------------
        var initSelectSpec = function(key, canCustom, comparisonFunction) {

            var i;
            var list = $scope.selectListMap[key];

            if(!Array.isArray(list) || list.length === 0) {
                return;
            }

            var value = $scope.form[key];

            for(i = 0; i < list.length; i++) {

                var item = list[i];
                var hasSame = false;

                if(!comparisonFunction) {
                    if(item === value || JSON.stringify(item) === JSON.stringify(value)) {
                        return;
                    }
                } else {
                    if(comparisonFunction(item, value)) {
                        return;
                    }
                }
            }

            if(canCustom && value) {
                $scope.customForm[key] = value;
                $scope.isCustom[key] = true;
            } else {
                $scope.form[key] = list[0];
                $scope.isCustom[key] = false;
            }
        }

        // --------------------------------
        // 初始化規格
        // --------------------------------
        var initSpec = function(orderitem) {

            if(orderitem) {
                var spec = shallowCopy(orderitem.spec);
                var specProps = spec.specProps;

                $scope.form[CountKey] = isNaN(spec[CountKey]) ? undefined : Number(spec[CountKey]);
                $scope.form.processRemark = spec.processRemark;
                $scope.form.userRemark = spec.userRemark;
                $scope.form.printingUnit = spec.printingUnit;
                $scope.form.deliveryDate = !spec.deliveryDate ? undefined : spec.deliveryDate / $scope.deliveryDateUnit.time;
                $scope.form[PdtSpecProps.Length] = isNaN(specProps[PdtSpecProps.Length]) ? undefined : Number(specProps[PdtSpecProps.Length]);
                $scope.form[PdtSpecProps.Width] = isNaN(specProps[PdtSpecProps.Width]) ? undefined : Number(specProps[PdtSpecProps.Width]);
                $scope.form[PdtSpecProps.Height] = isNaN(specProps[PdtSpecProps.Height]) ? undefined : Number(specProps[PdtSpecProps.Height]);
                $scope.form[PdtSpecProps.PdtStyle] = specProps[PdtSpecProps.PdtStyle];
                $scope.form[PdtSpecProps.MaterialType] = specProps[PdtSpecProps.MaterialType];
                $scope.form[PdtSpecProps.Version] = specProps[PdtSpecProps.Version];
                $scope.form[PdtSpecProps.AreaRange] = specProps[PdtSpecProps.AreaRange];
                $scope.form[PdtSpecProps.Thickness] = isNaN(specProps[PdtSpecProps.Thickness]) ? undefined : Number(specProps[PdtSpecProps.Thickness]);
                $scope.form[PdtSpecProps.Volume] = specProps[PdtSpecProps.Volume];
                $scope.form[PdtSpecProps.IsOneSide] = specProps[PdtSpecProps.IsOneSide];
                $scope.form[PdtSpecProps.IsTwoSide] = specProps[PdtSpecProps.IsTwoSide];
                $scope.form[PdtSpecProps.Dpi] = specProps[PdtSpecProps.Dpi];
                $scope.form[PdtSpecProps.ImageLength] = isNaN(specProps[PdtSpecProps.ImageLength]) ? undefined : Number(specProps[PdtSpecProps.ImageLength]);
                $scope.form[PdtSpecProps.ImageWidth] = isNaN(specProps[PdtSpecProps.ImageWidth]) ? undefined : Number(specProps[PdtSpecProps.ImageWidth]);
                $scope.form[PdtSpecProps.SleeveLength] = specProps[PdtSpecProps.SleeveLength];
                $scope.form[PdtSpecProps.ColorHex] = specProps[PdtSpecProps.ColorHex];
                $scope.form[PdtSpecProps.ClothingSizeList] = specProps[PdtSpecProps.ClothingSizeList];
                $scope.form[PdtSpecProps.PrintingColorCount] = specProps[PdtSpecProps.PrintingColorCount];
                $scope.form[PdtSpecProps.PrintingAreaList] = specProps[PdtSpecProps.PrintingAreaList];
                $scope.form[PdtSpecProps.PrintingPathCount] = specProps[PdtSpecProps.PrintingPathCount];
                $scope.form[PdtSpecProps.RollingColorHex] = specProps[PdtSpecProps.RollingColorHex];
            }
            
            if(Array.isArray($scope.printingUnitList) && $scope.printingUnitList.length > 0) {
                $scope.form.printingUnit = $scope.printingUnitList[0];
            } else {
                $scope.form.printingUnit = '個';
            }

            if($scope.form[PdtSpecProps.IsOneSide] === $scope.form[PdtSpecProps.IsTwoSide]) {
                if($scope.supportProps[PdtSpecProps.IsTwoSide]) {
                    onSideChange(true);
                } else if($scope.supportProps[PdtSpecProps.IsOneSide]) {
                    onSideChange(false);
                } 
            }

            initSelectSpec(PdtSpecProps.SizeUnit);
            initSelectSpec(PdtSpecProps.ThicknessUnit);
            initSelectSpec(PdtSpecProps.MaterialType, true);
            initSelectSpec(PdtSpecProps.Version, true);
            initSelectSpec(PdtSpecProps.PdtStyle, true);
            initSelectSpec(PdtSpecProps.Dpi);
            initSelectSpec(PdtSpecProps.AreaRange);
            initSelectSpec(PdtSpecProps.Thickness);
            initSelectSpec(PdtSpecProps.Volume);
            initSelectSpec(PdtSpecProps.ImageSizeUnit);
            initSelectSpec(PdtSpecProps.SleeveLength);
            initSelectSpec(PdtSpecProps.ColorHex, false, function(o1, o2) {
                if(o1 && o2 && o1.hex === o2.hex && o1.subHex === o2.subHex) {
                    return true;
                }

                return false;
            });
            initSelectSpec(PdtSpecProps.PrintingColorCount, false, function(o1, o2) {
                if(o1 && o2 && o1.name === o2.name) {
                    return true;
                }

                return false;
            });

            $scope.form[PdtSpecProps.ClothingSizeList] = getClothingSizeListForm();
            $scope.form[PdtSpecProps.PrintingAreaList] = getPrintingAreaListForm();
            initSelectSpec(PdtSpecProps.RollingColorHex, false, function(o1, o2) {
                if(o1 && o2 && o1.hex === o2.hex && o1.subHex === o2.subHex) {
                    return true;
                }

                return false;
            });

            initCountSelectType();
        }

        // ------------------------------
        // 初始化選擇衣服尺寸的選項
        // ------------------------------
        var getClothingSizeListForm = function() {

            var clothingSizeList = $scope.form[PdtSpecProps.ClothingSizeList];
            var spec_clothingSizeList = $scope.selectListMap[PdtSpecProps.ClothingSizeList];
            var new_clothingSizeList = [];

            // 將已選取的spec加入
            if(Array.isArray(clothingSizeList) && clothingSizeList.length > 0) {
                if(Array.isArray(spec_clothingSizeList) && spec_clothingSizeList.length > 0) {
                    for(var i = 0; i < clothingSizeList.length; i++) {
                        var clothingSize = clothingSizeList[i];
                        for(var j = 0 ; j < spec_clothingSizeList.length ; j++) {
                            var spec_clothingSize = spec_clothingSizeList[j];

                            if(isClothingSizeEqual(clothingSize, spec_clothingSize)) {
                                spec_clothingSize.count = clothingSize.count || 0;
                                new_clothingSizeList.push(spec_clothingSize);
                                break;
                            }
                        }
                    }
                }
            }

            if(new_clothingSizeList.length > 0) {
                new_clothingSizeList.sort(function(clothingSizeA, clothingSizeB) {
                    if(clothingSizeB.clothingSizeunit < clothingSizeA.clothingSizeunit) {
                        return 1;
                    } else if(clothingSizeB.clothingSizeunit > clothingSizeA.clothingSizeunit) {
                        return -1;
                    } else {
                        return 0;
                    }
                });
            }

            return new_clothingSizeList;
        }

        // ------------------------------
        // 初始化印刷範圍選項
        // ------------------------------
        var getPrintingAreaListForm = function() {

            var printingAreaList = $scope.form[PdtSpecProps.PrintingAreaList];
            var spec_printingAreaList = $scope.selectListMap[PdtSpecProps.PrintingAreaList];
            var new_printingAreaList = [];

            // 將已選取的spec加入
            if(Array.isArray(printingAreaList) && printingAreaList.length > 0) {
                if(Array.isArray(spec_printingAreaList) && spec_printingAreaList.length > 0) {
                    for(var i = 0; i < printingAreaList.length; i++) {
                        var printingArea = printingAreaList[i];
                        for(var j = 0 ; j < spec_printingAreaList.length ; j++) {
                            var spec_printingArea = spec_printingAreaList[j];

                            if(printingArea.name == spec_printingArea.name) {
                                // spec_printingArea.length = printingArea.length;
                                spec_printingArea.width = printingArea.width;
                                spec_printingArea.height = printingArea.height;
                                new_printingAreaList.push(spec_printingArea);
                                break;
                            }
                        }
                    }
                }
            }

            return new_printingAreaList;
        }

        // ------------------------------
        // 判斷選擇數量的顯示模式
        // ------------------------------
        var initCountSelectType = function() {
var countSelectType; // bundler：原本是隱式全域（沒有 var），strict mode 會 ReferenceError

            var clothingSizeList = $scope.selectListMap[PdtSpecProps.ClothingSizeList];

            if(Array.isArray(clothingSizeList) && clothingSizeList.length > 0) {
                countSelectType = CountLayoutType.ClothinghSize; // 尺碼與件數
            } else {
                countSelectType = CountLayoutType.Custom; // 輸入框
            }

            $scope.form.countSelectType = countSelectType;
        }

        // -------------------------------
        // 取得自訂資訊
        // -------------------------------
        var getCustomInfo = function() {

            var isError = false;

            resetErrorForm();
            
            var count = getOfferItemCount();

            if(!count || isNaN(count)) {
                $scope.errorForm[CountKey] = true;
                isError = true;
            }

            if(!$scope.form.printingUnit) {
                $scope.errorForm['printingUnit'] = true;
                isError = true;
            }
            
            if($scope.isCustom[PdtSpecProps.MaterialType] && !$scope.customForm[PdtSpecProps.MaterialType]) {
                $scope.errorForm[PdtSpecProps.MaterialType] = true;
                isError = true;
            }

            if($scope.isCustom[PdtSpecProps.Version] && !$scope.customForm[PdtSpecProps.Version]) {
                $scope.errorForm[PdtSpecProps.Version] = true;
                isError = true;
            }

            if($scope.isCustom[PdtSpecProps.PdtStyle] && !$scope.customForm[PdtSpecProps.PdtStyle]) {
                $scope.errorForm[PdtSpecProps.PdtStyle] = true;
                isError = true;
            }

            if($scope.supportProps[PdtSpecProps.Length] && (!$scope.form[PdtSpecProps.Length] || isNaN($scope.form[PdtSpecProps.Length]))) {
                $scope.errorForm[PdtSpecProps.Length] = true;
                isError = true;
            }

            if($scope.supportProps[PdtSpecProps.Width] && (!$scope.form[PdtSpecProps.Width] || isNaN($scope.form[PdtSpecProps.Width]))) {
                $scope.errorForm[PdtSpecProps.Width] = true;
                isError = true;
            }

            if($scope.supportProps[PdtSpecProps.Height] && (!$scope.form[PdtSpecProps.Height] || isNaN($scope.form[PdtSpecProps.Height]))) {
                $scope.errorForm[PdtSpecProps.Height] = true;
                isError = true;
            }
            
            if($scope.supportProps[PdtSpecProps.ImageLength] && (!$scope.form[PdtSpecProps.ImageLength] || isNaN($scope.form[PdtSpecProps.ImageLength]))) {
                $scope.errorForm[PdtSpecProps.ImageLength] = true;
                isError = true;
            }

            if($scope.supportProps[PdtSpecProps.ImageWidth] && (!$scope.form[PdtSpecProps.ImageWidth] || isNaN($scope.form[PdtSpecProps.ImageWidth]))) {
                $scope.errorForm[PdtSpecProps.ImageWidth] = true;
                isError = true;
            }

            if($scope.hasDeliveryDate && (!$scope.form.deliveryDate || isNaN($scope.form.deliveryDate))) {
                $scope.errorForm['deliveryDate'] = true;
                isError = true;
            }
            
            if(isError) {
                return false;
            }

            var orderSpec = {
                // 基本規格資料
                printingUnit: $scope.form.printingUnit,
                deliveryDate: $scope.hasDeliveryDate ? $scope.form.deliveryDate * $scope.deliveryDateUnit.time : undefined,
                deliveryDateUnit: $scope.hasDeliveryDate ? $scope.deliveryDateUnit : undefined,
                count: count,
                process:  Array.isArray($scope.form[ProcessKey]) && $scope.form[ProcessKey].length > 0 ? $scope.form[ProcessKey] : undefined,
            };

            var orderItemSpecProps = {
                [PdtSpecProps.Length]: $scope.supportProps[PdtSpecProps.Length] ? $scope.form[PdtSpecProps.Length] : undefined,
                [PdtSpecProps.Width]: $scope.supportProps[PdtSpecProps.Width] ? $scope.form[PdtSpecProps.Width] : undefined,
                [PdtSpecProps.Height]: $scope.supportProps[PdtSpecProps.Height] ? $scope.form[PdtSpecProps.Height] : undefined,
                [PdtSpecProps.SizeUnit]: $scope.form[PdtSpecProps.SizeUnit],
                [PdtSpecProps.IsOneSide]: $scope.supportProps[PdtSpecProps.IsOneSide] ? $scope.form[PdtSpecProps.IsOneSide] : false,
                [PdtSpecProps.IsTwoSide]: $scope.supportProps[PdtSpecProps.IsTwoSide] ? $scope.form[PdtSpecProps.IsTwoSide] : false,
                [PdtSpecProps.PdtStyle]: $scope.supportProps[PdtSpecProps.PdtStyle] ? $scope.form[PdtSpecProps.PdtStyle] : undefined,
                [PdtSpecProps.MaterialType]: $scope.supportProps[PdtSpecProps.MaterialType] ? $scope.form[PdtSpecProps.MaterialType] : undefined,
                [PdtSpecProps.Version]: $scope.supportProps[PdtSpecProps.Version] ? $scope.form[PdtSpecProps.Version] : undefined,
                [PdtSpecProps.Thickness]: $scope.supportProps[PdtSpecProps.Thickness] ? $scope.form[PdtSpecProps.Thickness] : undefined,
                [PdtSpecProps.ThicknessUnit]: $scope.form[PdtSpecProps.ThicknessUnit],
                [PdtSpecProps.AreaRange]: $scope.supportProps[PdtSpecProps.AreaRange] ? $scope.form[PdtSpecProps.AreaRange] : undefined,
                [PdtSpecProps.Volume]: $scope.supportProps[PdtSpecProps.Volume] ? $scope.form[PdtSpecProps.Volume] : undefined,
                [PdtSpecProps.Dpi]: $scope.supportProps[PdtSpecProps.Dpi] ? $scope.form[PdtSpecProps.Dpi] : undefined,
                [PdtSpecProps.ImageLength]: $scope.supportProps[PdtSpecProps.ImageLength] ? $scope.form[PdtSpecProps.ImageLength] : undefined,
                [PdtSpecProps.ImageWidth]: $scope.supportProps[PdtSpecProps.ImageWidth] ? $scope.form[PdtSpecProps.ImageWidth] : undefined,
                [PdtSpecProps.ImageSizeUnit]: $scope.form[PdtSpecProps.ImageSizeUnit],
                [PdtSpecProps.SleeveLength]: $scope.supportProps[PdtSpecProps.SleeveLength] ? $scope.form[PdtSpecProps.SleeveLength] : undefined,
                [PdtSpecProps.ColorHex]: $scope.supportProps[PdtSpecProps.ColorHex] ? $scope.form[PdtSpecProps.ColorHex] : undefined,
                [PdtSpecProps.ClothingSizeList]: $scope.supportProps[PdtSpecProps.ClothingSizeList] ? $scope.form[PdtSpecProps.ClothingSizeList] : undefined,
                [PdtSpecProps.PrintingColorCount]: $scope.supportProps[PdtSpecProps.PrintingColorCount] ? $scope.form[PdtSpecProps.PrintingColorCount] : undefined,
                [PdtSpecProps.PrintingAreaList]: Array.isArray($scope.form[PdtSpecProps.PrintingAreaList]) && $scope.form[PdtSpecProps.PrintingAreaList].length > 0 ? $scope.form[PdtSpecProps.PrintingAreaList] : undefined,
                [PdtSpecProps.PrintingPathCount]: $scope.supportProps[PdtSpecProps.PrintingPathCount] ? $scope.form[PdtSpecProps.PrintingPathCount] : undefined,
                [PdtSpecProps.RollingColorHex]: $scope.supportProps[PdtSpecProps.RollingColorHex] ? $scope.form[PdtSpecProps.RollingColorHex] : undefined,
                
                // todo
            };

            orderSpec.specProps = orderItemSpecProps;

            var result = {
                spec: orderSpec,
                processRemark: $scope.form.processRemark,
                userRemark: $scope.form.userRemark,
            }

            return result;
        }

        // ------------------------------
        // 依照數量顯示樣式取得數量
        // ------------------------------
        var getOfferItemCount = function() {

            var count = 0;

            switch($scope.form.countSelectType) {
                case CountLayoutType.Options: // 選單
                case CountLayoutType.Custom: // 輸入框
                    count = $scope.form[CountKey];
                    break;
                case CountLayoutType.ClothinghSize: // 尺碼與件數
                    var clothingSizeList = $scope.form[PdtSpecProps.ClothingSizeList];

                    for(var i = 0; i < clothingSizeList.length; i++) {
                        var clothingSize = clothingSizeList[i];
                        if(!isNaN(clothingSize.count) && clothingSize.count > 0) {
                            count += clothingSize.count;
                        }
                    }
                    break;
                default:
                    count = $scope.form[CountKey];
                    break;
            }

            return count;
        }

        // -------------------------------
        // 重置錯誤boolean
        // -------------------------------
        var resetErrorForm = function() {

            $scope.errorForm = {
                count: false,
                printingUnit: false,
                [PdtSpecProps.MaterialType]: false,
                [PdtSpecProps.Version]: false,
                [PdtSpecProps.PdtStyle]: false,
                [PdtSpecProps.Length]: false,
                [PdtSpecProps.Width]: false,
                [PdtSpecProps.Height]: false,
            };
        }

        // --------------------------------
        // 重置form
        // --------------------------------
        var resetForm = function() {

            $scope.form = {
                [CountKey]: undefined, // 選擇的數量
                [ProcessKey]: [], // 選擇的加工
                [PdtSpecProps.Length]: undefined, // 輸入的長
                [PdtSpecProps.Width]: undefined, // 輸入的寬
                [PdtSpecProps.Height]: undefined, // 輸入的高
                [PdtSpecProps.PdtStyle]: undefined, // 選擇的樣式
                [PdtSpecProps.MaterialType]: undefined, // 選擇的材質
                [PdtSpecProps.Version]: undefined, // 選擇的版型
                [PdtSpecProps.AreaRange]: undefined, // 選擇的面積範圍
                [PdtSpecProps.Thickness]: undefined, // 選擇的厚度
                [PdtSpecProps.Volume]: undefined, // 選擇的容量
                [PdtSpecProps.IsOneSide]: undefined, // 選擇單面
                [PdtSpecProps.IsTwoSide]: undefined, // 選擇雙面
                [PdtSpecProps.Dpi]: undefined, // 選擇的解析度
                [PdtSpecProps.ImageLength]: undefined, // 輸入的印刷尺寸長
                [PdtSpecProps.ImageWidth]: undefined, // 輸入的印刷尺寸寬
                [PdtSpecProps.SleeveLength]: undefined, // 選擇的袖長
                [PdtSpecProps.ColorHex]: undefined, // 選擇的顏色
                [PdtSpecProps.ClothingSizeList]: undefined, // 選擇的衣服尺寸
                [PdtSpecProps.PrintingColorCount]: undefined, // 選擇的印刷顏色數量
                [PdtSpecProps.PrintingAreaList]: undefined, // 選擇的印刷範圍
                [PdtSpecProps.PrintingPathCount]: undefined, // 可印刷幾處
                [PdtSpecProps.RollingColorHex]: undefined, // 滾邊色

                // 其他不需特別記錄key的欄位
                processRemark: undefined, // 加工備註
                userRemark: undefined, // 使用者備註說明
                printingUnit: undefined, // 數量單位
                deliveryDate: undefined, // 預計出貨
            };

            $scope.customForm = {
                [PdtSpecProps.MaterialType]: undefined,
                [PdtSpecProps.Version]: undefined,
                [PdtSpecProps.PdtStyle]: undefined,
            };
        }

        // ------------------------------
        // 兩個衣服尺寸是否相等
        // ------------------------------
        var isClothingSizeEqual = function(clothingSizeA, clothingSizeB) {

            var isEqual = clothingSizeA == clothingSizeB || (
                clothingSizeA.clothingSizeunit == clothingSizeB.clothingSizeunit
                && (clothingSizeA.clothingSizeunit != ProductUtil.ClothingSizeUnit.CUSTOM || clothingSizeA.customSizeName == clothingSizeB.customSizeName)
            );

            return isEqual;
        }

        // ------------------------------
        // [SCOPE] 是否選到該衣服尺寸
        // ------------------------------
        var isClothingSizeActive = function(option) {

            if(!Array.isArray($scope.form[PdtSpecProps.ClothingSizeList])){
                return false;
            }

            for(var i = 0 ; i < $scope.form[PdtSpecProps.ClothingSizeList].length ; i++) {
                if(isClothingSizeEqual($scope.form[PdtSpecProps.ClothingSizeList][i], option)) {
                    return true;
                }
            }

            return false;
        }

        // ------------------------------
        // [SCOPE] 取得衣服尺寸文字
        // ------------------------------
        var getClothingSizeString = function(clothingSize) {

            var text = '';

            if(!clothingSize) {
                return text;
            }

            if(clothingSize.clothingSizeunit == ProductUtil.ClothingSizeUnit.CUSTOM) {
                text = text + clothingSize.customSizeName;
            } else if(clothingSize.clothingSizeunit) {
                text = text + ProductUtil.getClothingSizeUnitText(clothingSize.clothingSizeunit);
            }

            return text;
        }

        // ------------------------------
        // [SCOPE] 當衣服尺寸更改時
        // ------------------------------
        var onClothingSizeChange = function(option, active, key) {

            toggleClothingSize(option);
        }

        // ------------------------------
        // 選取／取消 衣服尺寸項目
        // ------------------------------
        var toggleClothingSize = function(_clothingSize) {

            if(!_clothingSize.count) {
                _clothingSize.count = 0;
            }
            
            if(!Array.isArray($scope.form[PdtSpecProps.ClothingSizeList])){
                $scope.form[PdtSpecProps.ClothingSizeList] = [];
                $scope.form[PdtSpecProps.ClothingSizeList].push(_clothingSize);
                return;
            }

            for(var i = 0 ; i < $scope.form[PdtSpecProps.ClothingSizeList].length ; i++) {
                var option = $scope.form[PdtSpecProps.ClothingSizeList][i];

                if(isClothingSizeEqual(option, _clothingSize)) {
                    $scope.form[PdtSpecProps.ClothingSizeList].remove(i);
                    return;
                }
            }

            $scope.form[PdtSpecProps.ClothingSizeList].push(_clothingSize);
        }

        // ------------------------------
        // [SCOPE] 衣服尺寸數量更動時
        // ------------------------------
        var onClothingSizeCountChange = function(clothingSize) {

            var min = 0;

            if(isNaN(clothingSize.count) || clothingSize.count < min) {
                clothingSize.count = min;
            }
        }

        // ------------------------------
        // [SCOPE] 是否選到該印刷範圍
        // ------------------------------
        var isPrintingAreaActive = function(option, printingArea) {

            if(!Array.isArray($scope.form[PdtSpecProps.PrintingAreaList])){
                return false;
            }

            for(var i = 0 ; i < $scope.form[PdtSpecProps.PrintingAreaList].length ; i++) {
                if($scope.form[PdtSpecProps.PrintingAreaList][i].name == option.name) {
                    return true;
                }
            }

            return false;
        }

        // ------------------------------
        // [SCOPE] 當印刷範圍更改時
        // ------------------------------
        var onPrintingAreaChange = function(option, active, key) {

            togglePrintingArea(option);

            checkPrintingArea();
        }

        // ------------------------------
        // [SCOPE] 檢查印刷範圍數值
        // ------------------------------
        var checkPrintingArea = function() {

            var printingAreaList = $scope.form[PdtSpecProps.PrintingAreaList];

            $scope.isPrintingAreaError = false;

            if(!Array.isArray(printingAreaList) || printingAreaList.length === 0){
                return;
            }

            for(var i = 0 ; i < printingAreaList.length ; i++) {
                var printingArea = printingAreaList[i];
                // if(isNaN(printingArea.length) || printingArea.length <= 0) {
                //     printingArea.length = 1;
                // }
                if(isNaN(printingArea.width) || printingArea.width <= 0) {
                    printingArea.width = 1;
                }
                if(isNaN(printingArea.height) || printingArea.height <= 0) {
                    printingArea.height = 1;
                }
            }
        }

        // ------------------------------
        // 選取／取消 印刷範圍項目
        // ------------------------------
        var togglePrintingArea = function(_printingArea) {

            if(!Array.isArray($scope.form[PdtSpecProps.PrintingAreaList])){
                $scope.form[PdtSpecProps.PrintingAreaList] = [];
                $scope.form[PdtSpecProps.PrintingAreaList].push(_printingArea);
                return;
            }

            for(var i = 0 ; i < $scope.form[PdtSpecProps.PrintingAreaList].length ; i++) {
                var pro = $scope.form[PdtSpecProps.PrintingAreaList][i];

                if(pro.name == _printingArea.name) {
                    $scope.form[PdtSpecProps.PrintingAreaList].remove(i);
                    return;
                }
            }

            $scope.form[PdtSpecProps.PrintingAreaList].push(_printingArea);
        }

        // ------------------------------
        // [SCOPE] 取得顏色style
        // ------------------------------
        var getColorBackgroundStyle = function(color) {

            if(!color || !color.hex) {
                return undefined;
            }

            if(color.subHex) {
                return {
                    background: 'linear-gradient(-45deg, ' + color.subHex + ' 50%, ' + color.hex + ' 50%)',
                };
            } else {
                return {
                    backgroundColor: color.hex,
                }
            }
        }

        //==========================
        //  Variables
        //==========================
        $scope.printingUnitList = []; // 數量單位列表
        $scope.processList = []; // 加工列表
        $scope.selectListMap = {}; // 各個欄位列表
        $scope.supportProps = {}; // 支援的欄位
        $scope.isCustom = {};

        $scope.PdtSpecProps = PdtSpecProps;
        $scope.CountKey = CountKey;
        $scope.DimensionKey = DimensionKey;
        $scope.ProcessKey = ProcessKey;
        $scope.ImageDimensionKey = ImageDimensionKey;

        $scope.form = {
            [CountKey]: undefined, // 選擇的數量
            [ProcessKey]: [], // 選擇的加工
            [PdtSpecProps.Length]: undefined, // 輸入的長
            [PdtSpecProps.Width]: undefined, // 輸入的寬
            [PdtSpecProps.Height]: undefined, // 輸入的高
            [PdtSpecProps.PdtStyle]: undefined, // 選擇的樣式
            [PdtSpecProps.MaterialType]: undefined, // 選擇的材質
            [PdtSpecProps.Version]: undefined, // 選擇的版型
            [PdtSpecProps.AreaRange]: undefined, // 選擇的面積範圍
            [PdtSpecProps.Thickness]: undefined, // 選擇的厚度
            [PdtSpecProps.Volume]: undefined, // 選擇的容量
            [PdtSpecProps.IsOneSide]: undefined, // 選擇單面
            [PdtSpecProps.IsTwoSide]: undefined, // 選擇雙面
            [PdtSpecProps.Dpi]: undefined, // 選擇的解析度
            [PdtSpecProps.ImageLength]: undefined, // 輸入的印刷尺寸長
            [PdtSpecProps.ImageWidth]: undefined, // 輸入的印刷尺寸寬
            [PdtSpecProps.SleeveLength]: undefined, // 選擇的袖長
            [PdtSpecProps.ColorHex]: undefined, // 選擇的顏色
            [PdtSpecProps.ClothingSizeList]: undefined, // 選擇的衣服尺寸
            [PdtSpecProps.PrintingColorCount]: undefined, // 選擇的印刷顏色數量
            [PdtSpecProps.PrintingAreaList]: undefined, // 選擇的印刷範圍
            [PdtSpecProps.PrintingPathCount]: undefined, // 可印刷幾處
            [PdtSpecProps.RollingColorHex]: undefined, // 滾邊色

            // 其他不需特別記錄key的欄位
            processRemark: undefined, // 加工備註
            userRemark: undefined, // 使用者備註說明
            printingUnit: undefined, // 數量單位
            deliveryDate: undefined, // 預計出貨
            countSelectType: CountLayoutType.Options, // 數量顯示樣式
        };

        $scope.customForm = {
            [PdtSpecProps.MaterialType]: undefined,
            [PdtSpecProps.Version]: undefined,
            [PdtSpecProps.PdtStyle]: undefined,
        };

        $scope.errorForm = {
            [CountKey]: false,
            printingUnit: false,
            [PdtSpecProps.MaterialType]: false,
            [PdtSpecProps.Version]: false,
            [PdtSpecProps.PdtStyle]: false,
            [PdtSpecProps.Length]: false,
            [PdtSpecProps.Width]: false,
            [PdtSpecProps.Height]: false,
            [PdtSpecProps.ImageLength]: false,
            [PdtSpecProps.ImageWidth]: false,
        };

        $scope.deliveryDateUnit = {
            name: '日',
            time: 86400000,  
        }

        $scope.hasDeliveryDate = false; // 是否有預計出貨的欄位
        $scope.CountLayoutType = CountLayoutType; // 數量顯示樣式

        //==========================
        //  Methods
        //==========================
        $scope.onFormValueChange = onFormValueChange; // 當選項值更改時
        $scope.onCustomFormValueChange = onCustomFormValueChange; // 當自訂值更改時
        $scope.getSizeUnit = getSizeUnit; // 尺寸單位
        $scope.getSizeUnitByInt = getSizeUnitByInt; // 尺寸單位
        $scope.onSideChange = onSideChange; // 更換單/雙列印
        $scope.toggleProcess = toggleProcess; // 選取／取消 一般加工項目
        $scope.isSelectedProcess = isSelectedProcess; // 是否選取該一般加工項目
        $scope.checkSelectedProcess = checkSelectedProcess; // 檢查是否有勾選一般加工項目
        $scope.getCustomInfo = getCustomInfo; // 取得自訂資訊
        $scope.isClothingSizeActive = isClothingSizeActive; // 是否選到該衣服尺寸
        $scope.getClothingSizeString = getClothingSizeString; // 取得衣服尺寸文字
        $scope.onClothingSizeChange = onClothingSizeChange; // 當衣服尺寸更改時
        $scope.onClothingSizeCountChange = onClothingSizeCountChange; // 衣服尺寸數量更動時
        $scope.isPrintingAreaActive = isPrintingAreaActive; // 是否選到該印刷範圍
        $scope.onPrintingAreaChange = onPrintingAreaChange; // 當印刷範圍更改時
        $scope.checkPrintingArea = checkPrintingArea; // 檢查印刷範圍數值
        $scope.getColorBackgroundStyle = getColorBackgroundStyle; // 取得顏色style

        /**
         *
         * [DIFFERENT] 前後台審稿行為不一樣的function / variable等等..
         * 
         */

    	// --------------------------------
    	// init
    	// --------------------------------
    	var init = function() {

            resetForm();

    		if($scope.pdtClass) {
    			expandSpec($scope.pdtClass.products);
    			initSpec();
    		}
    	}

    	//==========================
    	//  前台 Events
    	//==========================

    	//==========================
    	//  前台 Variables
        //==========================

    	//==========================
    	//  前台 Methods
        //==========================

    	//==========================
    	//  Init
    	//==========================
    	init();
    }
]);

window.InifECApp.directive('customSpec', ['$rootScope', function($rootScope) {

    var _dir = {};

    var link = function($scope, $elem, $attr) {

    }

    _dir.link = link;
    _dir.restrict = 'AE';
    _dir.scope = {
    	pdtClass: "=",
    	getCustomInfo: "=",
    };
    _dir.templateUrl = "partials/directives/custom_spec.html";
    _dir.controller = "CustomSpecController";

    return _dir;
}]);